import { NotificationService } from '../../../shared/services/notification.service';
import {
  SelectTemplateDialogComponent,
  SelectTemplateDialogInputData,
} from '../../../shared/select-template-dialog/select-template-dialog.component';
import { Component, EventEmitter, Input, OnChanges, OnInit, Output } from '@angular/core';
import { UntypedFormBuilder, UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { filter } from 'rxjs/operators';
import { ViewTemplate } from '../../../models/template.model';
import { ReportView } from '../../../models/report.model';
import { TemplateDynamicService } from '../../../template-dynamic.service';
import { DynamicLocaleService } from '../../../dynamic-locale.service';
import { L10nTranslationService } from 'angular-l10n';

@Component({
  selector: 'ppt-actions-toolbar',
  templateUrl: './actions-toolbar.component.html',
  styleUrls: ['./actions-toolbar.component.scss'],
  standalone: false,
})
export class ActionsToolbarComponent implements OnInit, OnChanges {
  @Input() templates: ViewTemplate[] = [];
  @Input() reportData;
  @Input() currentView: ReportView;
  @Input() recordsCount: number;
  @Input() requiresSelectTempElement = true;
  @Input() requiresRecordNavigation = true;
  @Input() isUKFeaturesEnabled: boolean;
  @Output() navRecordNum: EventEmitter<number> = new EventEmitter<number>();
  @Output() templateChange: EventEmitter<number> = new EventEmitter<number>();

  @Output() templateAndViewChange: EventEmitter<any> = new EventEmitter<any>();

  public selectedTemplate: ViewTemplate;
  public selectedTemplateTitle: string;
  public pageIndex: number;

  navControlsFG: UntypedFormGroup;
  errorMessage: string;
  recordNumberFC: UntypedFormControl;
  prevRecordError = false;
  nextRecordError = false;

  constructor(
    private fb: UntypedFormBuilder,
    private notificationService: NotificationService,
    private templateDynamicService: TemplateDynamicService,
    private dynamicLocaleService: DynamicLocaleService,
    private translationService: L10nTranslationService
  ) {}

  ngOnInit() {
    this.navControlsFG = this.fb.group({
      recordNumber: [
        { value: 1, disabled: false },
        [Validators.required, Validators.min(1), Validators.max(this.recordsCount)],
      ],
    });
    this.recordNumberFC = this.navControlsFG.get('recordNumber') as UntypedFormControl;
    this.navRecordNum.emit(this.recordNumberFC.value);
  }

  ngOnChanges() {
    if (this.currentView && this.templates) {
      this.selectedTemplate = this.templates.find(temp => temp.templateId === this.currentView.templateId);
      this.selectedTemplateTitle = this.selectedTemplate
        ? `${this.selectedTemplate.templateName} ${this.translationService.translate('template.templateLbl')}`
        : '';
    }
  }

  public onRecordNumChange() {
    const recordNumbErrors = this.recordNumberFC.errors;
    switch (true) {
      case recordNumbErrors && recordNumbErrors.hasOwnProperty('required'): {
        this.errorMessage = 'Record Number should not be empty';
        this.nextRecordError = true;
        this.prevRecordError = true;
        break;
      }
      case recordNumbErrors && recordNumbErrors.hasOwnProperty('min'): {
        this.recordNumberFC.setValue(1);
        this.prevRecordError = true;
        break;
      }
      case recordNumbErrors && recordNumbErrors.hasOwnProperty('max'): {
        this.recordNumberFC.setValue(this.recordsCount);
        this.nextRecordError = true;
        break;
      }
      default: {
        this.nextRecordError = false;
        this.prevRecordError = false;
      }
    }
    this.navRecordNum.emit(this.recordNumberFC.value);
  }

  public prevRecord() {
    this.recordNumberFC.setValue(this.recordNumberFC.value - 1);
    this.onRecordNumChange();
  }

  public nextRecord() {
    this.recordNumberFC.setValue(this.recordNumberFC.value + 1);
    this.onRecordNumChange();
  }

  public openTemplates() {
    const options = { height: '90%', width: '90%', position: { top: '30px' } };
    const data: SelectTemplateDialogInputData = {
      templates: this.templates,
      reportId: this.reportData.reportId,
      selectedTemplateId: this.currentView.templateId,
      viewId: this.currentView.id,
    };
    this.notificationService
      .openDialog<number>(SelectTemplateDialogComponent, data, options)
      .pipe(filter((selectedTemplate: number) => selectedTemplate != null))
      .subscribe(selectedTemplateId => {
        this.fetchTemplateAndViwToSend(selectedTemplateId);
      });
  }

  private fetchTemplateAndViwToSend(selectedTemplateId: number) {
    this.templateDynamicService.setTemplateId(this.currentView.id, selectedTemplateId);
    const viewsAndTemplates = this.templateDynamicService.setViewandTemplate(
      this.dynamicLocaleService.getReportLocaleId(),
      this.currentView,
      selectedTemplateId
    );
    if (viewsAndTemplates && viewsAndTemplates.length) {
      const templateAndViewAndSelectedId = { selectedTemplateId, viewsAndTemplates };
      viewsAndTemplates.forEach((item, _index) => {
        this.templateDynamicService.saveAssociatedTemplates(this.reportData, item).subscribe(() => {
          this.templateAndViewChange.emit(templateAndViewAndSelectedId);
        });
      });
    } else {
      this.templateChange.emit(selectedTemplateId);
    }
  }
}
